import React, { Component } from 'react'
import '../styles/Confirmation.css'
import '../styles/Booking.css'
import '../styles/Navbar.css'
import '../styles/BookingContainer.css'
import MagnifierIcon from '../images/icons/magnifier.png'
import MailChecked from '../images/icons/mail-checked.png'
import FAQPattern from '../images/FAQ/FAQpattern.png'
import success from '../images/success.gif'
import fail from '../images/fail.gif'
import { injectIntl, defineMessages } from "react-intl"
import { withRouter, Link } from 'react-router-dom'
import qs from 'qs'
import { API_ROOT } from '../api-config'
import axios from 'axios'
import { Cookies } from 'react-cookie-banner'

const bookingStyle = {
  position: "static",
  alignItems: "center"
}

const buildAPI_URL = (idOrder, tokenOrder) => {
  return `${API_ROOT}FrontGetOrderDetails.php?id_order=${idOrder}&token_order=${tokenOrder}`
}

const tinyHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(16);
};

class Confirmation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: null,
      price: 0,
      multipayment: false,
      priceForMasterUser: 0,
      multipaymentHours: 0,
      error: false,
      loading: true,
      uid: null,
      isMasterUser: false
    }
  }

  checkOrderStatus = async () => {
    if (this.props.location.search) {
      const orderInfo = qs.parse(this.props.location.search.slice(1))
      if (orderInfo.email) {
        this.setState({
          email: orderInfo.email,
          price: orderInfo.price,
          uid: orderInfo.uid,
          loading: false
        })
      } else {
        await this.getOrderInfo(orderInfo.id, orderInfo.token, orderInfo.uid)
      }
    }
  }

  getOrderInfo = async (id, token, uid) => {
    axios.get(buildAPI_URL(id, token))
      .then(response => {
        const cookies = new Cookies()
        cookies.set('orderDetails', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        cookies.set('bookings', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        cookies.set('bookingsTokens', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        cookies.set('orderDetailsVouchers', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        cookies.set('vouchers', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        cookies.set('cart_step', 0, { path: '/', expires: new Date('2040-12-17T03:24:00') });

        cookies.remove("orderDetails")
        cookies.remove("bookings")
        cookies.remove("bookingsTokens")
        cookies.remove("orderDetailsVouchers")
        cookies.remove("vouchers")
        cookies.remove("cart_step")

        if (response.data.multipayment) {
            if (tinyHash(response.data.email) == uid) {
              this.setState({ isMasterUser: true});
            }
            Object.keys(response.data.players_multipayment_status).forEach((player) => {
              if (tinyHash(player) == uid) {
                this.setState({ 
                    error: !response.data.players_multipayment_status[player], 
                    loading: false,
                    email: player,
                    price: (player == response.data.email) ? response.data.price : response.data.multipayment_amount_per_player,
                    priceForMasterUser: response.data.multiplayer_amount_for_master_user,
                    multipaymentHours: response.data.multipayment_hours,
                    multipayment: response.data.multipayment
                  })
              }
            });
        } else if (!response.data.paid || response.data.paid === "null") {
	        this.setState({ error: true, loading: false })
        } else if (response.data.result) {
          this.setState({
            email: response.data.email,
            price: response.data.price,
            loading: false
          })
        } else {
          this.setState({ error: true, loading: false })
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  componentDidMount = async () =>  {
    if (this.props.location.search) {
      window.setTimeout(async () => {
        await this.checkOrderStatus()
      }, 1000)
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props
    return(
      <div className="confirmation">
        <div
          className="navbar navbar-sticky navbar-booking"
          style={bookingStyle}>
          <Link to="/">
            <div className="logo" style={{ padding: 0 }}>
              <img className="magnifier" src={MagnifierIcon} alt="magnifier-icon"/>
              <div className="logo-text">
                <div className="one-hour-title">one hour</div>
                <div className="one-hour-baseline">Escape Game</div>
              </div>
            </div>
          </Link>
          <h1>{formatMessage(messages.title)}</h1>
          <div
            className="booking-pricing booking-pricing--hidden"
            >
            <span>{formatMessage(messages.pricing)}</span><span className="question-mark--booking">?</span>
          </div>
        </div>
        <div className="booking-rectangle booking-rectangle-confirmation">
          <div
            style={{backgroundImage: `url(${FAQPattern})`}}
            className="booking-rectangle-pattern booking-rectangle-pattern-confirmation">
            {
              !this.state.error && !this.state.loading
              ?
                <div className="confirmation-title-container">
                  <h1><b>{formatMessage(messages.titleBold)}</b> <br/>
                    {formatMessage(messages.titleNormal)}
                  </h1>
                  <img src={MailChecked} alt=""/>
                </div>
              : null
            }
            {
              this.state.error && !this.state.loading
              ?
               <div className="confirmation-title-container">
                 <h1><b>{formatMessage(messages.failTitle)}</b></h1>
                 <img src={MailChecked} alt=""/>
               </div>
              : null
            }

          </div>
        </div>
        <div className="confirmation-wrapper">
          {
            !this.state.error && !this.state.loading
            ?
              <div className="confirmation-container">
                {(this.state.multipayment && this.state.isMasterUser) ? 
                  <div>
                    <h4>{formatMessage(messages.congratulations1)} <b>{this.state.priceForMasterUser} €</b> {formatMessage(messages.congratulations2)}</h4>
                    <p class="message-multipayment">{formatMessage(messages.multiPaymentWarning, { PRICE: this.state.price, REMAINING_TIME: this.state.multipaymentHours })}</p>
                  </div>
                  :
                  <h4>{formatMessage(messages.congratulations1)} <b>{this.state.price} €</b> {formatMessage(messages.congratulations2)}</h4>
                }
                <img src={success} alt="" style={{ width: '100%', maxWidth: '250px' }} />
                <p>{formatMessage(messages.emailSent1)} <b>{this.state.email}</b> {formatMessage(messages.emailSent2)}</p>
              </div>
            : null
          }
          {
            this.state.error && !this.state.loading
            ?
              <div className="confirmation-container">
                <h4>{formatMessage(messages.failText1)}</h4>
                <img src={fail} alt="" style={{ width: '100%', maxWidth: '250px' }} />
                <p>{formatMessage(messages.failText2)}</p>
              </div>
            : null
          }
        </div>
      </div>
    )
  }
}

const messages = defineMessages({
  pricing: {
    id: 'booking.pricing',
    defaultMessage: 'Tarifs'
  },
  title: {
    id: 'booking.title',
    defaultMessage: 'Réservation'
  },
  titleBold: {
    id: 'confirmation.titleBold',
    defaultMessage: 'Merci'
  },
  titleNormal: {
    id: 'confirmation.titleNormal',
    defaultMessage: 'et amusez-vous bien !'
  },
  congratulations1: {
    id: 'confirmation.congratulations1',
    defaultMessage: 'Votre paiement de'
  },
  congratulations2: {
    id: 'confirmation.congratulations2',
    defaultMessage: 'a bien été accepté'
  },
  multiPaymentWarning: {
    id: 'confirmation.multiPaymentWarning',
    defaultMessage: 'Une empreinte bancaire de {PRICE} € a été effectuée sur votre carte. Tous les participants ont {REMAINING_TIME} heures pour payer leur part. Vous serez débité du montant restant non réglé par les autres participants une fois le délai expiré.'
  },
  emailSent1: {
    id: 'confirmation.emailSent1',
    defaultMessage: 'Un email vous a été envoyé à'
  },
  emailSent2: {
    id: 'confirmation.emailSent2',
    defaultMessage: 'avec les détails de votre commande ainsi que le lieux et les informations sur le déroulement de la partie. Si vous n’avez pas reçu de mail de confirmation, veuillez nous contacter par mail à communication@one-hour.fr. Attention à bien vérifier la date et l’heure de votre réservation sur le mail reçu.'
  },
  cta: {
    id: 'confirmation.cta',
    defaultMessage: 'Voir votre email de confirmation'
  },
  failText1: {
    id: 'confirmation.failText1',
    defaultMessage: 'Votre paiement a échoué.'
  },
  failText2: {
    id: 'confirmation.failText2',
    defaultMessage: 'La réservation est bloquée 15 minutes afin de vous permettre de finaliser votre paiement. Vous allez recevoir un e-mail pour reprendre votre paiement directement. N\hésitez pas à nous contacter à contact@one-hour.fr pour finaliser la transaction.'
  },
  failTitle: {
    id: 'confirmation.failTitle',
    defaultMessage: 'Oups...'
  },
})

export default withRouter(injectIntl(Confirmation))



// WEBPACK FOOTER //
// ./src/components/Confirmation.js